<template>
<div>
<v-card>
  <v-card-title>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-text-field
        v-model="busqueda"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
        color="blue darken-3"
      ></v-text-field>
  </v-card-title>
  <v-data-table
    :headers="cabeceras"
    :items="lista"
    class="elevation-1"
    :search="busqueda"
  >
    <template v-slot:top>
    </template>
    <!-- customizando una columna del data table -->
      <template v-slot:item.fecha_produccion="{ item }">
        <span>{{  moment(item.fecha_produccion).format('DD/MM/YYYY HH:mm') }}</span>
      </template>

      <template v-slot:item.muestra_color="{ item }">
        <v-chip
          :color="item.valor"
        >
        </v-chip>
      </template>
      <template v-slot:item.proveniente_de="{ item }">
        <span v-if="item.viene_del_jumbo!=null">
          Lote: {{item.proveniente_de.lote.nombre_lote}} Maxisaco: {{item.proveniente_de.nro_jumbo}}
        </span>
      </template>

        <!-- enviar jumbo a reproceso -->
          <template v-slot:item.enviar_reproceso="{ item }">
            <span>
              <v-btn v-if="item.repaso_jumbos_id==null" color="orange darken-3" fab small dark class="mr-2" @click="enviar_a_reproceso(item)">
                <v-icon small>arrow_right_alt</v-icon>
              </v-btn>
            </span>
        </template>
        <!-- enviar jumbo a reproceso -->

        <!-- restablecer jumbo de reproceso -->
        <template v-slot:item.restablecer_jumbo="{ item }">
            <span>
              <v-btn v-if="item.repaso_jumbos_id!=null" color="green darken-1" fab small dark class="mr-2" @click="restablecer_jumbo(item)">
                <v-icon small>autorenew</v-icon>
              </v-btn>
            </span>
        </template>
        <!-- restablecer jumbo de reproceso -->

        <!-- asignar usuarios a parametro detalle -->
        <template v-slot:item.asignar_usuarios="{ item }">
          <v-btn color="orange darken-2" fab small dark class="mr-2" @click="asignar_usuarios(item)">
                <v-icon small>person_add</v-icon>
          </v-btn>
        </template>
        <!-- asignar usuarios a parametro detalle -->

        <!-- configurar opciones de un parametro (de tipo select) -->
        <template v-slot:item.configurar_opciones_parametro="{ item }">
          <v-btn v-if="item.tipo == 'select'" color="orange darken-2" fab small dark class="mr-2" @click="configurar_opciones_parametro(item)">
                <v-icon small>list</v-icon>
          </v-btn>
        </template>
        <!-- configurar opciones de un parametro (de tipo select) -->

        <template v-slot:item.subir_archivo="{ item }">
          <v-btn color="blue darken-2" fab small dark class="mr-2" @click="subir_archivo(item)">
                <v-icon small>publish</v-icon>
          </v-btn>
        </template>


    <!-- customizando una columna del data table -->

    <template v-slot:item.action="{ item }">
      <span v-for="accion in acciones" :key="accion.key">
        
        <!-- accion editar -->
        <span v-if="accion.key == 'editar'">
          <v-btn color="blue darken-3" fab small dark class="mr-2" @click="editarItem(item)">
            <v-icon small>edit</v-icon>
          </v-btn>
        </span>

        <!-- accion eliminar -->
        <span v-if="accion.key == 'eliminar'">
          <v-btn color="red darken-3" fab small dark @click="eliminarItem(item)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </span>

      </span>
    </template>

    <!-- accion cerrar lote -->
    <template v-slot:item.cerrar_lote="{ item }">
          <v-btn v-if="item.cerrado == 0" color="deep-orange darken-1" fab small dark class="mr-2" @click="cerrarLote(item)">
            <v-icon small>not_interested</v-icon>
          </v-btn>
    </template>
    <!-- accion cerrar lote -->

    <!-- accion items (Mantenedor Sectores Inspeccion PAC) -->
    <template v-slot:item.items="{ item }">
          <v-btn color="#0D47A1" fab small dark class="mr-2" @click="abrirItems(item)">
            <v-icon small>view_headline</v-icon>
          </v-btn>
    </template>
    <!-- accion cerrar lote -->

    <template v-slot:no-data>
      <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      No existen Registros
    </template>
  </v-data-table>
</v-card>
  
</div>
  
</template>
<script>
  export default {
    data: () => ({
      cabeceras:[],
      lista:[],
      acciones:[],
      busqueda:'',
    }),

    computed: {
    },

    watch: {
    },

    created () {
      
    },
    beforeDestroy() {
      Event.$off('inicializar_tabla');
    },
    mounted(){
      Event.$on('inicializar_tabla',(cabeceras,lista,acciones)=>{
        this.cabeceras = cabeceras;
        this.lista = lista;
        this.acciones = acciones;
        console.log('lista recibida en data table',lista);
      });
    },

    methods: {

      editarItem (item) {
        console.log('editando item...',item);
        this.$emit('editar',item);
      },

      eliminarItem (item) {
        const acc = this.acciones.find(acc => acc.key === 'eliminar');
        if(acc && acc.customDelete) {
          this.$emit('eliminar', item);
        } else {
          const index = this.lista.indexOf(item);
          confirm('Está seguro(a) de querer eliminar esta fila ?') && this.lista.splice(index, 1);
        }
      },

      cerrarLote(item){
        this.$emit('cerrar_lote',item);
      },

      enviar_a_reproceso(item){
        this.$emit('enviar_jumbo_a_reproceso',item);
      },

      restablecer_jumbo(item){
        // console.log('restableciendooo',item);
        this.$emit('restablecer_jumbo',item);
      },

      asignar_usuarios(item){
        this.$emit('asignarusuarios',item);
      },

      configurar_opciones_parametro(item){
        this.$emit('configurar_opciones',item);
      },

      subir_archivo(item){
        this.$emit('subir_archivo',item);
      },
      abrirItems(item){
        this.$emit('abrir_modal_items',item);
      }
    },
  }
</script>